/**
 * Order item holes
 *
 * @author Erik Orozco <erik.orozco@buildcentrix.com>
 * @copyright (c) 2025 Build Centrix
 */
import {
  AfterViewInit,
  Component,
  Inject,
  OnChanges,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { WdOrderItemHolesService } from 'src/app/services/orders/holes/wd-order-item-holes.service';

@Component({
  selector: 'app-order-item-holes',
  templateUrl: './order-item-holes.component.html',
  styleUrls: ['./order-item-holes.component.scss'],
})
export class OrderItemHolesComponent
  implements OnChanges, OnInit, AfterViewInit {
  isLoading = false;
  fileUrl;
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  // Order Item Hole Columns
  orderItemHoleColumns = [
    'number',
    'type',
    'inset',
    'offset',
    'rotation',
    'angle',
    'side',
    'width',
    'depth',
    'radius',
    'collar',
    'joint',
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<OrderItemHolesComponent>,
    public sanitizer: DomSanitizer,
    public wdOrderItemHolesService: WdOrderItemHolesService,
  ) {}

  /**
   * Initialize Sorting
   * @memberof ResultsComponent
   */
  initializeSorting(): void {
    // Set column sorting
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        // Note: Default sort by string column key, if column contains object
        // and you need to sort by object properties; add switch cases here
        default:
          // Sort column by column key (default to ignore lower case)
          return typeof item[property] === 'string'
            ? item[property]?.toLowerCase()
            : item[property];
      }
    };
    // Set sort
    this.dataSource.sort = this.sort;
  }

  /**
   * After View Init
   *
   * @memberof ResultsComponent
   */
  ngAfterViewInit(): void {
    this.initializeSorting();
  }

  /**
   * OnInit
   */
  ngOnInit() {
    this.setData();
  }

  /**
   * Is called when ngOnChanges LifeCycleHook is triggered when external changes
   * come into @Input() data then triggers updates in this component
   */
  ngOnChanges(): void {
    this.setData();
  }

  /**
   * Sets incoming "@Input() data" into this.dataSource<MatTableDataSource>.data
   */
  setData(): void {
    if (!(this.data?.holes instanceof Array)) {
      this.dataSource.data = [];
      return;
    }
    this.parseHoleData();
    this.dataSource.data = this.data.holes;
  }

  /**
   * Parses item hole data to display on table
   */
  parseHoleData(): void {
    this.wdOrderItemHolesService.parseItemHoleData(this.data);
  }

  /**
   * On Modal Dismiss
   */
  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}
